module.exports = __webpack_public_path__ + "14four/static/media/qrcode_hbomax.9c1390ce.png";